module.exports = __webpack_public_path__ + "static/media/pt-session-add.420f7113.svg";